"use strict";

const _ = require('lodash')

const histogramData = function(data, bin=10) {
  const start = parseInt(_.min(data)/bin)*bin
  const end = parseInt(_.max(data)/bin)*bin
  const x = _.range(start, end+1, bin)
  const y = new Array(x.length).fill(0)
  data.forEach(d => { y[parseInt(d/bin)-parseInt(start/bin)] += 1 })
  const xLabels = _.map(x, d => { return `${d}-${d+bin}` })  
  return { x: x, y: y, xLabels: xLabels }
}

const downloadTSV = function(tsv, filename) {
  var tsvFile;
  var downloadLink;
  // console.log(tsv)

  // TSV file
  tsvFile = new Blob([tsv], {type: "text/csv"});

  // Download link
  downloadLink = document.createElement("a");

  // File name
  downloadLink.download = filename;

  // Create a link to the file
  downloadLink.href = window.URL.createObjectURL(tsvFile);

  // Hide download link
  downloadLink.style.display = "none";

  // Add the link to DOM
  document.body.appendChild(downloadLink);

  // Click download link
  downloadLink.click();
}

export { histogramData, downloadTSV };
